import { useState, useCallback } from 'react';
import { Z_LAYERS } from '../constants/zLayers';

export const useTopMostLayer = () => {
  const [activeMenus, setActiveMenus] = useState<Map<string, number>>(new Map());
  const [topIndex, setTopIndex] = useState<number>(Z_LAYERS.DROPDOWN);

  const registerMenu = useCallback(
    (id: string) => {
      setTopIndex(prev => prev + 1);
      const newIndex = topIndex + 1;
      setActiveMenus(prev => {
        const next = new Map(prev);
        next.set(id, newIndex);
        return next;
      });
      return newIndex;
    },
    [topIndex]
  );

  const unregisterMenu = useCallback((id: string) => {
    setActiveMenus(prev => {
      const next = new Map(prev);
      next.delete(id);
      return next;
    });
  }, []);

  const getZIndex = useCallback(
    (id: string) => {
      return activeMenus.get(id) || Z_LAYERS.DROPDOWN;
    },
    [activeMenus]
  );

  return {
    registerMenu,
    unregisterMenu,
    getZIndex,
  };
};
